











































































































































































































import _ from "lodash";
import Modal from "../core/Modals/Modal.vue";
import EntretienEditModal from "./EntretienEditModal.vue";
import { MaterielApi } from "../api/MaterielApi";

export default {
    name: "EquipementDetailModal",
    components: { Modal, EntretienEditModal },
    props: {
        showModal: Boolean,
        equipement: Object,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            entretiens: [],
            mouvements: [],
            loadingEntretiens: false,
            loadingMouvements: false,
            showEntretienModal: false,
            selectedEntretien: null,
        };
    },
    methods: {
        load: function () {
            let self = this;
            if (!self.equipement || !self.equipement.id) {
                self.entretiens = [];
                self.mouvements = [];
                return;
            }

            self.loadingEntretiens = true;
            self.MaterielApi.getEntretiens({
                equipement_id: self.equipement.id,
            })
                .then(function (res) {
                    self.entretiens = res;
                    self.loadingEntretiens = false;
                })
                .catch(function (error) {
                    self.loadingEntretiens = false;
                    self.emitError(error);
                });

            self.loadingMouvements = true;
            self.MaterielApi.getMouvements({
                equipement_id: self.equipement.id,
                limit: 10,
            })
                .then(function (res) {
                    self.mouvements = res.data;
                    self.loadingMouvements = false;
                })
                .catch(function (error) {
                    self.loadingMouvements = false;
                    self.emitError(error);
                });
        },
        openEntretien: function (entretien) {
            this.selectedEntretien = entretien;
            this.showEntretienModal = true;
        },
        onEntretienSaved: function () {
            this.showEntretienModal = false;
            this.load();
            this.$emit("refresh");
        },
        deleteEntretien: function (entretien) {
            let self = this;

            swal({
                title: "Supprimer cette intervention ?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            })
                .then(function () {
                    return self.MaterielApi.deleteEntretien(entretien.id)
                        .then(function () {
                            self.$emit("toast", {
                                message: "Intervention supprimée",
                                kind: "success",
                            });
                            self.load();
                            self.$emit("refresh");
                        })
                        .catch(function (error) {
                            self.emitError(error);
                        });
                })
                .catch(function () {});
        },
        openRapport: function (mouvement) {
            let self = this;
            self.MaterielApi.openInNewTab(
                self.MaterielApi.rapportPdfUrl(mouvement.id)
            ).catch(function (error) {
                self.emitError(error);
            });
        },
        openEtiquette: function () {
            let self = this;
            if (!self.equipement || !self.equipement.id) {
                return;
            }
            self.MaterielApi.openInNewTab(
                self.MaterielApi.etiquettesPdfUrl([self.equipement.id])
            ).catch(function (error) {
                self.emitError(error);
            });
        },
        emitError: function (error) {
            this.$emit("toast", {
                message: _.get(
                    error,
                    "response.data.message",
                    "Une erreur est survenue"
                ),
                kind: "error",
            });
        },
        close: function () {
            this.$emit("close-modal");
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (value) {
                if (value) {
                    this.load();
                }
            },
        },
        equipement: function () {
            if (this.showModal) {
                this.load();
            }
        },
    },
};
